let STEPS_NAMES_BY_KEY = {
  sex: "User's gender",
  result: "User's goal",
  currentActivity: "User's preferred activities",
  height: "User's height",
  weight: "User's current weight",
  goalWeight: "User's goal weight",
  dietType: "User's diet type",
  fitnesLevel: "User's current fitness level",
  bodyZone: "User's preferred body zones",
  help: "User's inspiration",
  workHard: "User's preferred workout frequency",
  workTime: "User's preferred workout duration",
  sleep: "User's sleep duration",
  water: "User's water intake",
  motivation: "User's motivation",
  lifeChange: "Would your life change if you reached your ideal weight?",
  idealWeight: "User's last time ideal weight",
};

export default STEPS_NAMES_BY_KEY;
